export default __webpack_public_path__ + "static/media/Info icon.5fd948a6.svg";